import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/work-orders',
    name: 'POST_PRODUCTION_ORDER',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
